import React from 'react';
import { Button } from 'react-covideo-common';
import styled, { useTheme } from 'styled-components/macro';
import { NewModal } from 'lib/components';
import { theme } from 'lib/style';
import { Flex } from '../styles/layout';
import { useTranslation } from 'react-i18next';

const Content = styled.div<{ color: string }>`
  width: 600px;
  line-height: 28px;
  color: ${props => props.color};
`;

type Props = {
  handleModalClose: (shouldRefresh?: boolean) => void;
  handleModalSubmit: Function;
  content: string;
  headerText: string;
  submitButtonText: string;
};

export const VideoTrimMergeModal = (props: Props) => {
  const {
    handleModalClose,
    handleModalSubmit,
    headerText,
    content,
    submitButtonText,
  } = props;

  const { t } = useTranslation();
  const themes = useTheme();
  return (
    <NewModal
      headerText={headerText}
      headerTextStyle={{
        fontSize: theme.fontSizes.lg,
        lineHeight: '24px',
        color: themes.colors.neutral[100],
      }}
      closeModalOnBackdropOrEscPress={true}
      closeModal={() => {
        handleModalClose();
      }}
      style={{
        content: {
          padding: '32px',
          minWidth: 'auto',
        },
      }}
    >
      <Content color={themes.colors.neutral[100]}>{`${content}`}</Content>
      <Flex
        flexDirection='row'
        justifyContent='flex-end'
        margin='32px 0 0 0'
        gap='10px'
      >
        <Button
          text={t('Cancel')}
          variant='secondary'
          onClick={() => handleModalClose()}
        />
        <Button text={submitButtonText} onClick={() => handleModalSubmit()} />
      </Flex>
    </NewModal>
  );
};
